import { whitelistFieldName } from '../../constants';
import messages from '../../constants/logMessages.json';
import tracking from '../../tracking/tracking';
import { AnalyticsConst } from '../../types';
import { CheckBoxPayload, inputFieldPayload } from '../../types/designSystem';
import { checkForPII } from '../helpers';
import logging, { getMessage } from '../logging';

const { errorHeading, errorBold } = messages;

const getChangeInputComponentLabel = (
  componentType: string,
  label: string | undefined,
  value: string | undefined
) => {
  switch (componentType) {
    case 'radioGroup':
    case 'toggle':
    case 'datePicker':
      return label || value || AnalyticsConst.NOT_SET;

    default:
      return value || AnalyticsConst.NOT_SET;
  }
};

const getDatePickerComponentLabel = (
  behaviour = '',
  value = '',
  fieldName = ''
) => ({
  eventAction: `${fieldName}: ${behaviour}`,
  eventLabel: value,
});
/**
 * textField | DropDown
 * @param payload {object}
 * @returns {void}
 */
export const changeInputFieldHandler = (payload: inputFieldPayload) => {
  try {
    const { data, trackProps, componentType, action } = payload;
    const { value, fieldName, trackValue, variant, version, label } =
      payload.trackProps;
    let componentLabel: string = '';

    // PII suppress, whitelisted policy start date date picker
    if (
      !whitelistFieldName.test(fieldName) &&
      label &&
      checkForPII(label) === 'mask' &&
      componentType !== 'datePicker'
    ) {
      componentLabel = 'mask';
    } else if (!trackValue || (trackValue && /mask/i.test(trackValue))) {
      componentLabel = 'mask';
    } else if (/capture/i.test(trackValue))
      componentLabel = getChangeInputComponentLabel(
        componentType,
        label,
        value
      );

    tracking.analyticsEngagementTracking({
      event: 'et_change',
      eventAction: fieldName || AnalyticsConst.NOT_SET,
      eventLabel: componentLabel,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
        action,
      },
      data,
    });
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'changeInputFieldHandler',
        e instanceof Error ? e.message : String(e),
      ]),
      errorHeading,
      errorBold
    );
  }
};

type genericFormElementPayload = CheckBoxPayload;

/**
 * 'checkbox':
 *
 */
export const checkInputFieldHandler = (payload: genericFormElementPayload) => {
  try {
    const { data, trackProps, componentType } = payload;
    const { fieldName, trackValue, label, status, variant, version } =
      payload.trackProps;

    let componentLabel: string = '';

    // PII suppress.
    if (label && checkForPII(label) === 'mask') {
      componentLabel = 'mask';
    }

    // Default behaviour - Mask.
    if (!trackValue || (trackValue && /mask/i.test(trackValue)))
      componentLabel = 'mask';
    else if (/capture/i.test(trackValue) && componentLabel !== 'mask')
      componentLabel = label || AnalyticsConst.NOT_SET;

    tracking.analyticsEngagementTracking({
      event: `et_${status === 'active' ? 'check' : 'uncheck'}`,
      eventAction: `${status === 'active' ? 'check' : 'uncheck'}: ${
        fieldName || AnalyticsConst.NOT_SET
      }`,
      eventLabel: componentLabel,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
        action: status ? 'check' : 'uncheck',
      },
      data,
    });
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'checkInputFieldHandler',
        e instanceof Error ? e.message : String(e),
      ]),
      errorHeading,
      errorBold
    );
  }
};

export const datePickerChangeSelectHandler = (payload: inputFieldPayload) => {
  try {
    const {
      data,
      trackProps,
      componentType,
      action,
      trackProps: {
        value,
        fieldName,
        trackValue,
        variant,
        label,
        behaviour,
        version,
      },
    } = payload;

    const isDatePicker = componentType === 'datePicker';
    let componentLabel = 'mask';

    if (!whitelistFieldName.test(fieldName)) {
      if (label && !isDatePicker) {
        componentLabel = checkForPII(label) as string;
      }
    } else if (trackValue && /capture/i.test(trackValue)) {
      componentLabel = value || label || AnalyticsConst.NOT_SET;
    }

    const augmentData = getDatePickerComponentLabel(
      behaviour,
      componentLabel,
      fieldName
    );

    tracking.analyticsEngagementTracking({
      event: `et_${action}`,
      eventAction: augmentData.eventAction || AnalyticsConst.NOT_SET,
      eventLabel: augmentData.eventLabel || AnalyticsConst.NOT_SET,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
        action,
        version,
      },
      data,
    });
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'datePickerChangeSelectHandler',
        e instanceof Error ? e.message : String(e),
      ]),
      errorHeading,
      errorBold
    );
  }
};
